import { NavigateFunction } from 'react-router-dom';

export async function handleApiResponse(res: Response, navigate?: NavigateFunction) {
  if (res.status === 401) {
    window.localStorage.clear();
    if (navigate) navigate('/');
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    let serverMsg = '';
    try {
      const body = await res.clone().json();
      serverMsg = body?.message || body?.error || body?.title || '';
    } catch {}
    if (serverMsg) throw new Error(serverMsg);
    if (res.status >= 500) throw new Error('__server_error__');
    if (res.status === 400) throw new Error('__bad_request__');
    throw new Error('__api_error__');
  }
  return res;
}

export function handleAxiosError(err: any, navigate?: NavigateFunction) {
  if (err && err.response && err.response.status === 401) {
    window.localStorage.clear();
    if (navigate) navigate('/');
    throw new Error('Unauthorized');
  }
  throw err;
}
